import { Title } from '@solidjs/meta'
import type { Component } from 'solid-js'
import Container from '~/components/Container'
import PaymentGatewaysManager from '~/layers/PaymentGatewaysManager'

/**
 * Pasarelas de pago de la empresa activa (y, para root, las del sistema).
 *
 * La pantalla es fina a propósito: todo el trabajo está en
 * `PaymentGatewaysManager`, que se reutiliza en la ficha de cada empresa. Así
 * configurar una pasarela se hace igual desde los dos sitios.
 */
const PagosConfigPage: Component = () => (
  <Container>
    <Title>Pasarelas de pago | Florez Jaramillo</Title>

    <div>
      <h1 class="text-2xl font-bold text-foreground">Pasarelas de pago</h1>
      <p class="text-sm text-foreground-subtle">Configura una o varias cuentas; la marcada por defecto es la que cobra.</p>
    </div>

    <PaymentGatewaysManager allowSystemScope />
  </Container>
)

export default PagosConfigPage
